import React, { useState, useEffect } from 'react';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { TextArea, CustomButton } from '../../Components/Common/FormInputs';
import validate from '../../hooks/validations/FormValidationRules';
import useFormvalidation from '../../hooks/validations/useFormvalidation';
import useOrder from '../../hooks/useOrder';

const OrderCancel = ({ orderstatus, orderid, closeModal }) => {

    const { cancleOrderapi } = useOrder();

    const [formValues, setFormValues] = useState({
        comment: '',
    });

    const handleNext = () => {


        const payload = {
            order_ids: [orderid],
            comment: values.comment || '',
            current_status: orderstatus,
        };

        cancleOrderapi.mutate(payload, {
            onSuccess: (res) => {
                closeModal()
            }
         
        });
    };

    const {
        handleChange,
        handleSubmit,
        errors,
        values,
        setValues,
    } = useFormvalidation(handleNext, validate, formValues);
    return (
        <>
            <div className="mt-2">
                <TextArea
                    name="comment"
                    placeholder="Enter Reason"
                    label={"Reason"}
                    onChange={handleChange}
                    value={values.comment}
                    error_msg={errors.comment}
               
                />
            </div>
            <div className="d-flex gap-2 justify-content-end mt-4 mb-2">
                <CustomButton label={'Cancel Orders'} handleSubmit={handleSubmit} />
            </div>
        </>
    );
};

export default OrderCancel;
